import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { ConnectionState } from './use-pusher-channel';
import { StatusBox } from '../status-box';

const isMinimumClientsConnected = (connectedClientCount, minimumClients) => Number(connectedClientCount) >= minimumClients

export function MinimumConnectedClientsNotification({ minimumClients, connectionStatus, channel, statusClassName, notificationMessage, onConnectedClientCountChange }) {
  const [connectedClientCount, setConnectedClientCount] = useState(null);
  const pusherNotReady = connectionStatus !== ConnectionState.CONNECTED;

  useEffect(() => {
    if (channel && connectionStatus === ConnectionState.CONNECTED) {
      channel.bind('pusher:subscription_count', (data) => setConnectedClientCount(data.subscription_count));
    }

    return () => channel?.unbind('pusher:subscription_count', setConnectedClientCount);
  }, [connectionStatus, channel]);

  useEffect(() => {
    if (onConnectedClientCountChange && connectedClientCount) {
      onConnectedClientCountChange({
        connectedClientCount,
        minimumClientsConnected: isMinimumClientsConnected(connectedClientCount, minimumClients)
      });
    }
  }, [connectedClientCount, onConnectedClientCountChange, minimumClients]);


  if (pusherNotReady || isMinimumClientsConnected(connectedClientCount, minimumClients)) {
    return null;
  }

  return (
    <StatusBox type='info' className={statusClassName} >
      <i className='far fa-hourglass fa-spin fa-lg mr-2 text-info' />

      {notificationMessage}
    </StatusBox>
  )
}

MinimumConnectedClientsNotification.propTypes = {
  minimumClients: PropTypes.number.isRequired,
  connectionStatus: PropTypes.string,
  channel: PropTypes.object,
  statusClassName: PropTypes.string,
  notificationMessage: PropTypes.string,
  onConnectedClientCountChange: PropTypes.func
}

MinimumConnectedClientsNotification.defaultProps = {
  notificationMessage: 'Waiting for all clients to connect'
}
